// Test IDs for Pathways to Purpose Housing Application
export const LANDING = {
  startApplyBtn: 'landing-start-apply-btn',
  resumeBtn: 'landing-resume-btn',
  adminBtn: 'landing-admin-btn',
  accommodationBtn: 'landing-accommodation-btn',
  criteriaLink: 'landing-criteria-link',
  rentValue: 'landing-rent-value',
  depositValue: 'landing-deposit-value',
  availability: 'landing-availability',
};

export const CRITERIA_PAGE = {
  page: 'criteria-page',
  version: 'criteria-version',
  list: 'criteria-list',
  item: (id) => `criteria-item-${id}`,
  startApplyBtn: 'criteria-start-apply-btn',
};

export const APPLY = {
  progressBar: 'apply-progress-bar',
  nextBtn: 'apply-next-btn',
  prevBtn: 'apply-prev-btn',
  saveBtn: 'apply-save-btn',
  submitBtn: 'apply-submit-btn',
  // Contact
  legalName: 'apply-legal-name',
  preferredName: 'apply-preferred-name',
  phone: 'apply-phone',
  email: 'apply-email',
  currentAddress: 'apply-current-address',
  contactPreference: 'apply-contact-pref',
  isAdult: 'apply-is-adult',
  moveInDate: 'apply-move-in',
  occupantsCount: 'apply-occupants-count',
  addOccupant: 'apply-add-occupant',
  // Housing
  housingType: 'apply-housing-type',
  housingDuration: 'apply-housing-duration',
  reasonMoving: 'apply-reason-moving',
  needHousingDate: 'apply-need-housing-date',
  rentedBefore: 'apply-rented-before',
  landlordName: 'apply-landlord-name',
  landlordContact: 'apply-landlord-contact',
  rentalExplain: 'apply-rental-explain',
  // Income
  employmentStatus: 'apply-employment-status',
  employer: 'apply-employer',
  jobTitle: 'apply-job-title',
  employerAddress: 'apply-employer-address',
  supervisor: 'apply-supervisor',
  employerPhone: 'apply-employer-phone',
  lengthEmployment: 'apply-length-employment',
  grossMonthlyIncome: 'apply-gross-monthly-income',
  payFrequency: 'apply-pay-frequency',
  otherIncome: 'apply-other-income',
  householdMonthlyIncome: 'apply-household-monthly-income',
  canPayDeposit: 'apply-can-pay-deposit',
  depositAvailableDate: 'apply-deposit-available-date',
  authorizeContact: 'apply-authorize-contact',
  uploadDocs: 'apply-upload-docs',
  // References
  addReference: 'apply-add-reference',
  refConsent: 'apply-ref-consent',
  // Story
  storyQ: (i) => `apply-story-q${i}`,
  micBtn: (i) => `apply-mic-q${i}`,
  pnaBtn: (i) => `apply-pna-q${i}`,
  followupBtn: (i) => `apply-followup-q${i}`,
  // Lease ack
  ackChk: (k) => `apply-ack-${k}`,
  // Signature
  certify: 'apply-certify',
  signatureName: 'apply-signature-name',
  consentAI: 'apply-consent-ai',
  consentVerify: 'apply-consent-verify',
  confirmation: 'apply-confirmation',
  downloadPdf: 'apply-download-pdf',
  withdrawBtn: 'apply-withdraw-btn',
};

export const ADMIN = {
  loginEmail: 'admin-login-email',
  loginPassword: 'admin-login-password',
  loginBtn: 'admin-login-btn',
  twoFaCode: 'admin-2fa-code',
  twoFaSubmit: 'admin-2fa-submit',
  totpSecret: 'admin-totp-secret',
  logoutBtn: 'admin-logout-btn',
  navDashboard: 'admin-nav-dashboard',
  navSettings: 'admin-nav-settings',
  navCriteria: 'admin-nav-criteria',
  navAudit: 'admin-nav-audit',
  navAccommodation: 'admin-nav-accommodation',
  appsTable: 'admin-apps-table',
  appRow: (id) => `admin-app-row-${id}`,
  statusFilter: 'admin-status-filter',
  searchInput: 'admin-search',
  exportCsv: 'admin-export-csv',
  aiSummaryBtn: 'admin-ai-summary-btn',
  unlockStoryBtn: 'admin-unlock-story-btn',
  statusSelect: 'admin-status-select',
  saveStatusBtn: 'admin-save-status-btn',
  reasonCodeSelect: 'admin-reason-code-select',
  objectiveReview: {
    card: 'admin-objective-review-card',
    mark: (critId, mark) => `admin-review-${critId}-${mark}`,
    note: 'admin-review-note',
    saveBtn: 'admin-review-save-btn',
    outcome: 'admin-review-outcome',
    editBtn: 'admin-review-edit-btn',
  },
  storyUnlock: {
    panel: 'admin-story-unlock-panel',
    reasonSelect: 'admin-unlock-reason-select',
    attestationCheckbox: 'admin-attestation-checkbox',
    confirmBtn: 'admin-confirm-unlock-btn',
    blockedMsg: 'admin-story-blocked-msg',
  },
  addNoteInput: 'admin-add-note',
  addNoteBtn: 'admin-add-note-btn',
  downloadPdfBtn: 'admin-download-pdf-btn',
  property: {
    rent: 'admin-prop-rent',
    deposit: 'admin-prop-deposit',
    availability: 'admin-prop-availability',
    utilities: 'admin-prop-utilities',
    save: 'admin-prop-save',
  },
};

export const ACCOM = {
  request: 'accom-request',
  additional: 'accom-additional',
  contact: 'accom-contact',
  submit: 'accom-submit-btn',
};
